(function(){
    'use strict';

    angular
    .module('appback')
    .controller('ChatController', ChatController)
 
    ChatController.$inject = ["socket","ChatService","GenerallabService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function ChatController(socket,ChatService,GenerallabService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
        vm.generalLab = GenerallabService;
        vm.misCategorias = [];
        vm.salaActual = false;
        vm.mensajes = [];
        vm.user = {};
        vm.usuarios = [];
        vm.usersonline = [];
        vm.msg = "";
    	console.log("CONNECTION CHAT")
		console.log(vm)
        socket.on("bigchat:msg",function(data){
        	console.log("LLEGA ALGO",data);
            if(data.msg.typeChat=='sala'){
            	if(data.msg.room==vm.salaActual){
    	        	vm.mensajes.push(data);
    	        }
    	        vm.ponerUltimoMensaje(data);
            }
            if(data.msg.typeChat=='user'){
                if(data.msg.user.id==vm.salaActual){
                    vm.mensajes.push(data);
                }
                vm.ponerUltimoMensajeUser(data);
            }
            vm.revisarScroll();

	    })
        socket.on("bigchat:usersonline",function(data){
            vm.usersonline = data;
            console.log("datausersonline",data);
        });
        vm.ponerUltimoMensaje = function(data){
        	for(var cont = 0;cont<vm.misCategorias.length;cont++){
        		if(vm.misCategorias[cont].id==data.msg.room){
        			if(!angular.isDefined(vm.misCategorias[cont].lastMessage)){
        				vm.misCategorias[cont].lastMessage = [];
        			}
                    vm.misCategorias[cont].lastMessage.push(data);
                    vm.misCategorias[cont].lastDate = data.created;
                    if(data.msg.user.id!=vm.user.id){
            			vm.misCategorias[cont].porver++;
                    }
        		}
        	}
        	console.log("misCats",vm.misCategorias);
        }
        vm.ponerUltimoMensajeUser = function(data){
            for(var cont = 0;cont<vm.usuarios.length;cont++){
                if(vm.usuarios[cont].id==data.msg.user.id){
                    if(!angular.isDefined(vm.usuarios[cont].lastMessage)){
                        vm.usuarios[cont].lastMessage = [];
                    }
                    vm.usuarios[cont].lastMessage.push(data);
                    vm.usuarios[cont].lastDate = data.created;
                    vm.usuarios[cont].porver++;
                }
            }
            console.log("misCats",vm.misCategorias);
        }
        vm.enviarPeticion = function(){
            var id = vm.generalLab.currentPeticion.id;
            var lims_id = vm.generalLab.currentPeticion.lims_id;
            vm.msg = "<a target='_blank' class='btn btn-warning' href='https://ulab.uranovet.com/backend/altcrm/content/view?id="+id+"&type=peticion&lang_id=1&ContentSearch%5Bnode_type%5D=resultadopeticion&ContentSearch%5Bpeticion_id%5D="+id+"'><span class='material-symbols-outlined'>chat</span>"+lims_id+"</a>";
            vm.enviarMensaje();
        }

		//socket.emit('create', {room:vm.id,username:vm.userName,cookie:vm.cookie});
       	vm.init = function() {
       		ChatService.getMisCategorias(function(data){
                vm.user = data.user;
       			vm.misCategorias = data.misCategorias;
                vm.usuarios = data.usuarios;
                socket.emit('app:getUsersActivos');
       		})
       	}
       	vm.entrarSala = function(sala,type) {
            /*if(angular.isDefined(sala.porver)){
                vm.generalLab.num_chat -= sala.porver;
            }*/
            sala.porver = 0;
            vm.mensajes = [];
            vm.typeChat = type;
       		vm.salaActual = sala.id;
            if(type=='user'){
                vm.nameS = sala.name;
            }
            if(type=='sala'){
                vm.nameS = sala.nombre;
            }
            ChatService.getMensajesSala(vm,function(data){
                vm.mensajes = data.mensajes;
                vm.revisarScroll();
                
            });
       	}

        vm.revisarScroll = function(){
            $timeout(function(){
                var div = $(".chat_scrolldiv");
                div.scrollTop(div.prop('scrollHeight'));
            },100)
        }

       	vm.enviarMensaje = function(){
            if(vm.msg==""){
                return false;
            }
            var msgC = {room:vm.salaActual,user:vm.user,msg:vm.msg,typeChat : vm.typeChat, name:vm.nameS};
			socket.emit('bigchat:msg', msgC);
               console.log("enviando",msgC);
            if(vm.typeChat=='user'){
                vm.mensajes.push({msg:msgC});
                vm.revisarScroll();
            }
			vm.msg="";

            ChatService.enviarMensaje(msgC,function(data){

            });

       	}
       	
    }
  
})();